import { gql } from '@apollo/client';

export const REGULAR_HEALTH_CHECKUP_REPORTS = gql`
  query regularHealthCheckupReports($page: Int, $limit: Int) {
    client {
      regularHealthCheckupReports(page: $page, limit: $limit) {
        totalCount
        list {
          id
          officeSnapshot {
            id
            name
          }
          title
          startOn
          endOn
        }
      }
    }
  }
`;

export interface RegularHealthCheckupReportsQueryVariables {
  page?: number | null;
  limit?: number | null;
}

export interface RegularHealthCheckupReports {
  client: {
    regularHealthCheckupReports: {
      totalCount: number;
      list: RegularHealthCheckupReport[];
    };
  };
}

export interface RegularHealthCheckupReport {
  id: string;
  officeSnapshot?: {
    id: string;
    name: string;
  };
  title: string;
  startOn: string;
  endOn: string;
}
